// src/pages/ContactUs.js
import React from "react";
import { NavLink } from "react-router-dom";

const Breadcrumb = () => (
  <div
    className="optech-breadcrumb"
    style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}
  >
    <div className="container">
      <h1 className="post__title">Contact Us</h1>
      <nav className="breadcrumbs">
        <ul>
          <li><NavLink to="/">Home</NavLink></li>
          <li aria-current="page">Contact Us</li>
        </ul>
      </nav>
    </div>
  </div>
);

const ContactInfoSection = () => (
  <section className="section optech-section-padding">
    <div className="container">
      <div className="row">
        {/* Left: Info */}
        <div className="col-lg-6 d-flex align-items-center">
          <div className="optech-default-content mr40">
            <h2>Get In Touch</h2>
            <p>
              Reach out today and let our language experts guide you with accurate, timely,
              and culturally precise solutions tailored to your needs.
            </p>
            <div className="optech-contact-info-column">
              <div className="optech-contact-info">
                <i className="ri-map-pin-2-fill" />
                <h5>Address</h5>
                <p>242 W Hudson St, Long Beach, <br />NY 11561, USA</p>
              </div>
              <div className="optech-contact-info">
                <i className="ri-mail-fill" />
                <h5>Contact</h5>
                <a href="mailto:support@ra-inc.com">support@ra-inc.com</a>
                <a href="tel:(516) 208-3462">(516) 208-3462</a>
              </div>
            </div>
            <p>Office Hours: Mon – Sat: 9:00 AM – 7:00 PM</p>
          </div>
        </div>

        {/* Right: Form */}
        <div className="col-lg-6">
          <div
            className="optech-main-form bg-light1 ml60"
            data-aos="fade-up"
            data-aos-duration="800"
          >
            <h3>Fill The Contact Form</h3>
            <p>Feel free to contact with us, we don’t spam your email</p>
            <form>
              <div className="row">
                <div className="col-lg-6">
                  <div className="optech-main-field">
                    <input type="text" placeholder="Your name" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="optech-main-field">
                    <input type="tel" placeholder="Phone number" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="optech-main-field">
                    <input type="email" placeholder="Email address" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="optech-main-field">
                    <textarea name="message" placeholder="Write your message" />
                  </div>
                </div>
                <div className="col-lg-12">
                  <button
                    id="optech-main-form-btn"
                    type="button"
                    data-text="Send Message"
                  >
                    <span className="btn-wraper">Send Message</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const MapSection = () => (
  <div className="optech-map-page">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.78111925171!2d-73.67386002416352!3d40.59058657141212!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c26ff5e003765d%3A0x8035bd8f9d6b119f!2s242%20W%20Hudson%20St%2C%20Long%20Beach%2C%20NY%2011561%2C%20USA!5e0!3m2!1sen!2sin!4v1743771187339!5m2!1sen!2sin"
      width="100%"
      height="550"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Office Location"
    />
  </div>
);

const ContactUs = () => (
  <>
    <Breadcrumb />
    <ContactInfoSection />
    <MapSection />
  </>
);

export default ContactUs;